// extracted by mini-css-extract-plugin
export default {"title":"cF9TzpsntxGJVXmKFB6Re","error":"_1uzo5Ds65o0Ww5lvMHkUEK","delete":"_1BaISMJrq23uRpeMedF5Sj","attach":"_3nOu-wHmeYUAIQxArBsTGv","ph":"_1q2IlTROYKhH8FFpl20TJF"};